import Icon from 'veui/components/Icon'
import { IconHighSquare } from 'dls-icons-vue'

Icon.register('high-square', IconHighSquare)
